import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  Component,
} from "react";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";
import { Auth } from "../../../contextapi/Authcontext/Authcontext";

function Editortinyme({ value }) {
  // console.log(value);
  const userDetail = JSON.parse(localStorage.getItem("userToken"));
  const { editorState, setEditorState } = useContext(Auth);
  const imageSender = async (file) => {
    const accessToken = `Bearer ${userDetail.accesstoken}`;
    return await axios
      .post("https://www.bailkolhu.com/api/admin/s3", file, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: accessToken,
        },
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        return error;
      });
  };
  const handleUpload = async (file) => {
    const formImage = new FormData();
    formImage.append("image", file);
    const response = await imageSender(formImage);
    if (response) {
      return response.data;
    }
    return response.data;
  };
  useEffect(() => {
    setEditorState({
      ...editorState,
      editorHtml: value === undefined ? "" : value,
    });
  }, []);
  var useDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };
  return (
    <>
      <Editor
        onInit={(evt, editor) => (editorRef.current = editor)}
        value={editorState.editorHtml}
        onEditorChange={(html) => {
          setEditorState({ editorHtml: html });
        }}
        apiKey="ir61kxcs1i792eyfzgxybd3k850ojqeojrosj6x7v1l8fagv"
        init={{
          selector: "textarea | template",
          height: 600,
          plugins: [
            "link autolink",
            "advlist",
            "autolink",
            "lists",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "code",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "code",
            "help",
            "wordcount",
            "template",
          ],
          toolbar: "link | template",
          template_mdate_format: "%m/%d/%Y : %H:%M",
          template_replace_values: {
            username: "Jack Black",
            staffid: "991234",
            inboth_username: "Famous Person",
            inboth_staffid: "2213",
          },
          template_preview_replace_values: {
            preview_username: "Jack Black",
            preview_staffid: "991234",
            inboth_username: "Famous Person",
            inboth_staffid: "2213",
          },
          templates: [
            {
              title: "Example 1 for multiple images side by side ",
              description: "Here You can add left image and right image",
              content: `
              <div class="row mb-5">
                <div class="col-lg-9">
                  <h5>Kachi Ghani Oil:</h5>
                  <p>
                    The oil that is produced from mustard seeds is known as
                    &quot;Kachi Ghani&quot; oil. The traditional process of
                    &quot;cold-pressing&quot; is used to extract it. By using no
                    heat or chemicals, this technique involves crushing the
                    mustard seeds. The term &quot;Kachi Ghani&quot; translates
                    to &quot;cold pressing&quot; in Hindi, highlighting the
                    significance of this technique.
                  </p>
                  <p>
                    The vital fatty acids, vitamins, minerals, and other
                    beneficial components of the oilseeds are all still present
                    in this cooking oil. It improves the flavour of food with
                    its distinctive flavour profile and potent scent. Moreover,
                    the way Kachi Ghani oil is made keeps all the nutrition
                    intact. The process of extraction doesn&#39;t involve high
                    heat, which means the nutrients in the oil stay preserved.
                    This makes Kachi Ghani oil a healthier choice for you.
                  </p>
                </div>
                <div class="col-lg-3">
                  <img
                    src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg"
                    class="img-fluid"
                    alt="bail Kolhu"
                  />
                </div>
              </div>
              <div class="row mb-5">
                <h3>Health Benefits of Kachi Ghani Oil</h3>
                <span class="mb-3"
                  >is rich in heart-healthy fats, such as monounsaturated and
                  polyunsaturated fats. These fats play a role in reducing LDL
                  (&quot;bad&quot;) cholesterol levels and boosting HDL
                  (&quot;good&quot;) cholesterol levels, promoting a healthier
                  heart. In addition, these healthy fats also help fight
                  inflammation, which is a major risk factor for heart disease.
                  By incorporating Kachi Ghani oil into your diet, you can
                  support your heart&#39;s well-being and take charge of your
                  cardiovascular health.</span
                ><br />
                <div class="col-lg-3">
                  <img
                    src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg"
                    class="img-fluid"
                    alt="bail Kolhu"
                  />
                </div>
                <div class="col-lg-9">
                  <span class="text-black"
                    ><span class="fs-5">Boosts immunity</span></span
                  >:<span
                    >Kachi Ghani oil contains a significant amount of vitamin E,
                    a mighty nutrient known to give our immunity a fantastic
                    boost. Vitamin E is like a superhero for our cells! It can
                    provide a shield to cells from harmful free radicals which
                    otherwise can cause damage to them.</span
                  ><br />

                  <span class="text-black"
                    ><span class="fs-5">Promotes hair health</span></span
                  >:<span
                    >Kachi Ghani oil not only nourishes and strengthens your
                    hair, but it also acts as a protective shield against heat
                    styling and environmental damage. Say goodbye to dry,
                    damaged hair and hello to healthy, gorgeous locks with the
                    help of Kachi Ghani oil. Embrace the power of nature and let
                    your hair radiate with vitality and beauty!</span
                  ><br />

                  <span class="text-black"
                    ><span class="fs-5">Relieves pain</span></span
                  >:<span
                    >The anti-inflammatory qualities of kachi ghani oil can aid
                    in reducing pain caused by diseases like arthritis, muscle
                    aches, and headaches.</span
                  ><br />

                  <span class="text-black"
                    ><span class="fs-5">Promotes skin health:</span></span
                  >:<span
                    >Fatty acids found in abundance in kachi ghani oil help
                    moisturise and nourish the skin. It can be beneficial in
                    preventing the skin from damage caused by the sun and
                    hazardous environmental pollutants.</span
                  ><br />
                  <p>
                    Kachi Ghani oil is a multi-purpose oil for cooking, massage,
                    and skincare. It is full of vital nutrients and offers
                    numerous health benefits.
                  </p>
                </div>
                <h5>Potential Side Effects of Kachi Ghani Oil</h5>
                <p>
                  Kachi Ghani oil is generally considered safe for consumption
                  and does not have significant known side effects. However, as
                  with any food product, individual reactions or sensitivities
                  can vary. It&#39;s important to note that moderation is key
                  when using any type of oil, including Kachi Ghani oil, as
                  excessive consumption can lead to weight gain and other health
                  issues.
                </p>
              </div>
              <div class="row mb-5">
                <div class="col-lg-9">
                  <h5>Refined Oil</h5>
                  <p>
                    The oil that has undergone processing to eliminate
                    contaminants is known as refined oil. Typically, this
                    procedure entails heating the oil at high temperatures
                    before using chemicals to remove any impurities.
                  </p>

                  <p>
                    Refined oil is lower-quality oil than Kachi Ghani oil.
                    Refined oil generally has a higher smoke point compared to
                    unrefined oils. The refining process removes impurities that
                    contribute to a lower smoke point in unrefined oils. This
                    makes refined oil suitable for high-temperature cooking
                    methods like deep-frying.
                  </p>
                  <h5>Health Benefits of Refined Oil</h5>
                  <p>Here are some of the health benefits of refined oil:</p>

                  <span class="text-black"
                    ><span class="fs-5">Cholesterol control</span></span
                  >:<span
                    >Rich in monounsaturated and polyunsaturated fats, these
                    oils can help reduce LDL (&quot;bad&quot;) cholesterol
                    levels when they replace saturated fats in your diet.</span
                  ><br />

                  <span class="text-black"
                    ><span class="fs-5">Guarding your heart</span></span
                  >:<span
                    >Packed with heart-healthy monounsaturated and
                    polyunsaturated fats, refined oils could contribute to a
                    reduced risk of cardiovascular issues.</span
                  ><br />

                  <span class="text-black"
                    ><span class="fs-5"
                      >Embracing the goodness of healthy fats</span
                    ></span
                  >:<span
                    >Refined oils, especially those high in omega-3 fatty acids,
                    have been associated with improved cognitive function and
                    reduced risk of neurodegenerative disorders like
                    Alzheimer&#39;s disease.</span
                  ><br />

                  <p>
                    Remember, moderation is key when incorporating refined oils
                    into your diet. Opt for options with low trans-fat content
                    to ensure good health.
                  </p>
                </div>
                <div class="col-lg-3">
                  <img
                    src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg"
                    class="img-fluid"
                    alt="bail Kolhu"
                  />
                </div>
              </div>

              <div class="row mb-5">
                <div class="col-lg-3">
                  <img
                    src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg"
                    class="img-fluid"
                    alt="bail Kolhu"
                  />
                </div>

                <div class="col-lg-9">
                  <h5>Potential Side Effects of Refined Oil</h5>
                  <p>
                    Like other cooking oils, refined oil may cause adverse
                    effects if used excessively or under particular conditions.
                    Here are some things to think about:
                  </p>

                  <span class="text-black"
                    ><span class="fs-5">Weight gain</span></span
                  >:<span
                    >Refined oils have a lot of calories, therefore eating too
                    much of them can make you gain weight. Oils should be used
                    moderately as part of a balanced diet.</span
                  >

                  <span class="text-black"
                    ><span class="fs-5"
                      >Increased risk of heart disease</span
                    ></span
                  >:<span
                    >When consumed in excess, some refined oils, especially
                    those rich in saturated fats, may raise cholesterol levels
                    and increase the risk of heart disease. It is advised to
                    restrict the consumption of saturated and trans fats and to
                    use oils containing large amounts of healthy fats, such as
                    monounsaturated or polyunsaturated fats.</span
                  ><br />
                </div>
                <span class="text-black"
                  ><span class="fs-5">Allergic reactions :</span></span
                ><span
                  >While rare, some individuals may have allergies or
                  sensitivities to specific types of refined oils, such as
                  soybean oil, peanut oil, or other commonly used oils. If you
                  have known allergies, it&#39;s important to read food labels
                  carefully and avoid oils that may trigger an allergic
                  reaction.</span
                >

                <span class="text-black"
                  ><span class="fs-5">Digestive issues:</span></span
                ><span
                  >In some cases, consuming excessive amounts of refined oils
                  can lead to digestive discomfort, such as diarrhoea or stomach
                  upset. This can be due to the high-fat content or the specific
                  type of oil being consumed. Moderation and choosing only the
                  best- refined oils are crucial to avoiding such issues.</span
                >
              </div>
              <div class="row mb-5">
                <div class="col-lg-9">
                  <h5>Comparison of Kachi Ghani Oil and Refined Oil</h5>
                  <h5>Comparing Health Aspects:</h5>
                  <p>
                    When considering health factors, both Kachi Ghani Oil and
                    Refined Oil have their unique characteristics. Kachi Ghani
                    Oil stands out for retaining more natural nutrients and
                    antioxidants due to minimal processing. It contains vitamins
                    E and K, omega-3 and omega-6 fatty acids, and antioxidants,
                    which offer potential health benefits like improved heart
                    health, reduced inflammation, and strengthened immunity.
                  </p>

                  <p>
                    On the other hand, Refined Oil undergoes a refining process
                    that removes impurities, including some natural antioxidants
                    and nutrients. However, this process results in more stable
                    oil with a longer shelf life. Refined oils contain lower
                    levels of monounsaturated fats in comparison to kachi ghani
                    mustard oil, which makes them less healthy than kachi ghani
                    oil.
                  </p>

                  <h5>Let&#39;s compare their nutrients:</h5>
                </div>
                <div class="col-lg-3">
                  <img
                    src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg"
                    class="img-fluid"
                    alt="bail Kolhu"
                  />
                </div>
                <table class="border border-dark">
                  <tr class="border border-dark">
                    <th>Nutrient</th>
                    <th>Kachi Ghani Oil&nbsp; &nbsp;</th>
                    <th>Refined Oil</th>
                  </tr>
                  <tr class="border border-dark">
                    <td>Monounsaturated fats &nbsp; &nbsp;</td>
                    <td>High</td>
                    <td>Low</td>
                  </tr>
                  <tr class="border border-dark">
                    <td>Polyunsaturated fats</td>
                    <td>High</td>
                    <td>Low</td>
                  </tr>
                  <tr class="border border-dark">
                    <td>Vitamin E &nbsp; &nbsp;</td>
                    <td>High</td>
                    <td>Low</td>
                  </tr>
                  <tr class="border border-dark">
                    <td>Omega-3 fatty acids</td>
                    <td>High</td>
                    <td>Low</td>
                  </tr>
                  <tr class="border border-dark">
                    <td>Hydrogenated</td>
                    <td>No</td>
                    <td>Yes</td>
                  </tr>
                  <tr class="border border-dark">
                    <td>Trans fats</td>
                    <td>No</td>
                    <td>Yes</td>
                    <td></td>
                  </tr>
                </table>
                <p>
                  In the table you can see, Kachi Ghani oil is a much healthier
                  choice than refined oil. It is more nutritious and does not
                  contain trans fats.
                </p>
              </div>
              <div class="row mb-5">
                <div class="col-lg-3">
                  <img
                    src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg"
                    class="img-fluid"
                    alt="bail Kolhu"
                  />
                </div>
                <div class="col-lg-9">
                  <h5>Conclusion</h5>
                  <p>
                    The best Kachi Ghani Oil is one that has natural goodness,
                    distinct flavours, and potential health benefits, and
                    appeals to those seeking a more traditional and
                    nutrient-rich option. On the other hand, the best quality
                    refined oil offers versatility and longer shelf life, making
                    it a suitable choice for high-temperature cooking. However,
                    if we have to choose the best oil for cooking between the
                    two then Kachi Ghani oil is the better choice for your
                    health. It is more nutritious, healthier and does not
                    contain trans fats. So, if you are looking for healthy
                    cooking oil, Kachi Ghani oil is the best option.
                  </p>
                </div>
              </div>
              `,
            },
            {
              title: "Example 2 for 5 images",
              description:
                "These values are replaced in the preview, but not when inserted into the editor content.",
              content:
                '<div><blockquote><p>KDFKSFLSKFKSJFKSKF</p></blockquote> </div><div class="row mb-5"><div class="col-lg-12"><p> Bail Kolhu stands as the countrys most preferred Kacchi Ghani Mustard oil </p></div> </div> <div class="row mb-5"><div class="col-md-4"><img src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg" class="img-fluid" alt="bail Kolhu"></div><div class="col-md-4"><img src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg" class="img-fluid" alt="bail Kolhu"></div><div class="col-md-4"><img src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg" class="img-fluid" alt="bail Kolhu"> </div></div> <h3 class="text-black mb-3">Factors that contributed to Bail Kolhus unmatched growth</h3>    <div class="row mb-5"><div class="col-md-3"><img src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg" class="img-fluid" alt="bail Kolhu"></div><div class="col-md-9"><span><h5>Quality:</h5> There have been many changes The stateall parameters in terms  of health and taste. So, you dont have to compromise on health.</span>   <span><h5 class="mt-2">Process:</h5> The manufacturing process of Bail Kolhu, right from sourcing the finest mustard seeds,testing, packaging, and 5-micron filtration to its distribution, brings the purest and aromatic Mustard oil to your kitchen.This process ensures that you get the authentic taste of Kachhi Ghani Sarso tel.</span> <span><h5 class="mt-2"> Packaging: </h5>Bail Kolhu has always given prime importance to its customers.It maintains that even in packaging, it provides anti- skid handles with a reliable bottle grip, making it easy for you to pour the oil directly from the bottles.</span> </div>  </div>  <div class= "row mb-5">   <div class="col-md-9"><span><h5 class="mt-2">Health benefits:</h5>Kacchi Ghani Mustard oil has numerous health benefits. It is  suitable for your digestive system and helps you improve your immunity as it has high omega-3 and Omega-6 fatty acids.  </span> <span> <h5 class="mt-2">Availability:</h5>ail stores in the country. Moreover issue   with Bail Kolhu. </span>   <p class="mt-3">  People chi Ghani oil,   culture and </p></p> </div >  <div class="col-md-3"><img src="https://www.davidhechler.com/wp-content/uploads/2016/07/500x500-dummy-image.jpg"class="img-fluid"alt="bailKolhu"></div></div >',
            },
          ],
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:16px }",
          //added new plugin for template
          height: 350,
          selector: "textarea#open-source-plugins",
          plugins:
            "preview importcss searchreplace autolink autosave directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount imagetools textpattern help charmap quickbars emoticons",
          imagetools_cors_hosts: ["picsum.photos"],
          menubar: "file edit view insert format tools table help",
          toolbar:
            "visualblocks | undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save | insertfile image media template link anchor codesample | ltr rtl  ",
          toolbar_sticky: true,
          autosave_ask_before_unload: true,
          autosave_interval: "30s",
          autosave_prefix: "{path}{query}-{id}-",
          autosave_restore_when_empty: false,
          autosave_retention: "2m",
          image_advtab: true,
          image_caption: true,
          quickbars_selection_toolbar:
            "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
          noneditable_noneditable_class: "mceNonEditable",
          toolbar_mode: "sliding",
          contextmenu: "link image table",
          skin: useDarkMode ? "oxide-dark" : "oxide",
          content_css: useDarkMode ? "dark" : "default",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
          visualblocks_default_state: true,
          end_container_on_empty_block: true,
          file_picker_callback: function (callback, value, meta) {
            if (meta.filetype == "image") {
              const input = document.createElement("input");
              input.setAttribute("type", "file");
              input.setAttribute("accept", "image/*");
              input.click();
              input.onchange = async function () {
                const file = input.files[0];
                const reader = new FileReader();
                const fileUrl = await handleUpload(file);
                // console.log(fileUrl,"outputttt")
                callback(fileUrl?.uploaded[0], {
                  alt: file.name,
                });
                reader.readAsDataURL(file);
              };
            }
          },
        }}
      />
    </>
  );
}

export default Editortinyme;
